import { Component, Input, OnInit } from '@angular/core';
import { ViewCell } from 'ng2-smart-table';

@Component({
  template: `
    <button (click)="example($event)">Click me</button>
  `,
})
export class ButtonRenderComponent implements OnInit {

  public renderValue;

  @Input() value;

  constructor() {  }

  ngOnInit() {
    console.log('init');
    this.renderValue = this.value;
  }

  example(data) {
    // alert(this.renderValue);
    console.log(data);
  }


}
